/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import api from "../../api/api";
import Style from "../../assets/css/main.module.css";
import avatar from "../../assets/icons/avatar.svg";
import calenderIcon from "../../assets/icons/calender.svg";
import caretDown from "../../assets/icons/caret-down-dark.svg";
import editIcon from "../../assets/icons/edit-pen-light.svg";
import uploadIcon from "../../assets/icons/upload.svg";
import { currencyFormat } from "../../library/currency";
import { drawerAction } from "../../store/features/deviceSlice";
import editChildrenSchema from "../../validation/editChildrenSchema";
import { useDrawer } from "../drawer/DrawerProvider";
import ErrorMessage from "../ui/ErrorMessage";

export default function Item({ item, index }) {
  const { openDrawer } = useDrawer();
  const handleChildrenEditDrawer = () => {
    openDrawer(<EditChildren item={item} />, `Edit ${item.name} Details`);
  };
  const [viewMemberships, setViewMemberships] = useState(false);
  const [memberships, setMemberships] = useState([]);
  const viewMembershipsHandler = async () => {
    if (!viewMemberships) {
      const res = await api.childrenMemberships(item.id);
      if (res.status === 200) {
        setMemberships(res.data.data);
      }
    }
    setViewMemberships(!viewMemberships);
  };
  return (
    <div
      className={`${Style.bg_primary_200} position-relative p-2 d-flex flex-column justify-content-start gap-2 mb-5 ${viewMemberships ? "rounded-top" : "rounded"}`}
    >
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-end">
            <img
              src={item.profile || avatar}
              alt=""
              style={{
                position: "absolute",
                top: "-20px",
                right: 20,
                height: "114px",
                width: "114px",
                borderRadius: "50%",
              }}
            />
          </div>
        </div>
      </div>
      <div>
        <div className={`${Style.fs_16} ${Style.fw_300}`}>
          Child {index + 1}
        </div>
        <div className="d-flex align-items-center gap-2">
          <div
            className={`${Style.fs_20} ${Style.fw_400} ${Style.text_primary}`}
          >
            Name:
          </div>
          <div className={`${Style.fs_20} ${Style.fw_400} text-capitalize`}>
            {item.name}
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <div
            className={`${Style.fs_20} ${Style.fw_400} ${Style.text_primary}`}
          >
            Gender:
          </div>
          <div className={`${Style.fs_20} ${Style.fw_400} text-capitalize`}>
            {item.gender === "male"
              ? "Boy"
              : item.gender === "female"
                ? "Girl"
                : ""}
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <div
            className={`${Style.fs_20} ${Style.fw_400} ${Style.text_primary}`}
          >
            Class:
          </div>
          <div className={`${Style.fs_20} ${Style.fw_400} text-capitalize`}>
            {item.class}
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <div
            className={`${Style.fs_20} ${Style.fw_400} ${Style.text_primary}`}
          >
            School:
          </div>
          <div className={`${Style.fs_20} ${Style.fw_400} text-capitalize`}>
            {item.school}
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <div
            className={`${Style.fs_20} ${Style.fw_400} ${Style.text_primary}`}
          >
            Date of Birth:
          </div>
          <div className={`${Style.fs_20} ${Style.fw_400} text-capitalize`}>
            {item.date_of_birth}
          </div>
        </div>
        <div className="d-flex align-items-center gap-2 pt-3">
          <div className="w-50">
            <button
              type="button"
              onClick={handleChildrenEditDrawer}
              className={`${Style.bg_blue_200} ${Style.fs_16} ${Style.fw_600} text-light border-0 py-1 rounded children-viewm-btn w-100`}
            >
              <img src={editIcon} alt="edit-pen" style={{ height: "20px" }} />
              Edit Profile
            </button>
          </div>
          <div className="w-50">
            <button
              type="button"
              onClick={viewMembershipsHandler}
              className={`${Style.fs_16} ${Style.fw_600} ${Style.bg_white} text-dark border-0 py-1 rounded children-viewm-btn w-100 d-none d-md-block`}
            >
              View Memberships
              <img src={caretDown} alt="caret-down" className="ps-2" />
            </button>
            <button
              type="button"
              onClick={viewMembershipsHandler}
              className={`${Style.fs_16} ${Style.fw_600} ${Style.bg_white} text-dark border-0 py-1 rounded children-viewm-btn w-100 d-block d-md-none`}
            >
              Memberships
              <img src={caretDown} alt="caret-down" className="ps-2" />
            </button>
          </div>
        </div>
      </div>
      {memberships.length > 0 && viewMemberships && (
        <div className={`${Style.bg_gray_200} rounded-bottom p-3`}>
          {memberships.map((membership) => (
            <div
              className={`${Style.border_primary} border-start border-5 ps-2 d-flex flex-column gap-2 mb-2 bg-light px-2`}
            >
              <div
                className={`${Style.text_primary} ${Style.fs_20} ${Style.fw_600} d-flex align-items-center justify-content-between`}
              >
                <div>{membership.membership.name}</div>
                <div>{currencyFormat(membership.amount)}</div>
              </div>
              <div className={`${Style.fs_16} ${Style.fw_400} d-flex`}>
                <div className={`${Style.text_primary}`}>Duration:</div>
                <div className="ps-2">
                  {membership.membership.duration_type === "date" &&
                    membership.membership.duration}
                  {membership.membership.duration_type === "month" &&
                    `${membership.membership.duration} Month`}
                  {membership.membership.duration_type === "hour" &&
                    `${membership.membership.duration} Hours`}
                </div>
              </div>
              <div className={`${Style.fs_16} ${Style.fw_400} d-flex`}>
                <div className={`${Style.text_primary}`}>Subscribe On: </div>
                <div className="ps-2">
                  {new Date(membership.created_at).toLocaleString("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                  })}
                </div>
              </div>
              <div className={`${Style.fs_16} ${Style.fw_400} d-flex`}>
                <div className={`${Style.text_primary}`}>Valid Till: </div>
                <div className="ps-2">{membership.expiry}</div>
              </div>
            </div>
          ))}
        </div>
      )}
      {memberships.length === 0 && viewMemberships && (
        <div className={`${Style.bg_gray_200} rounded-bottom p-3`}>
          No membership available
        </div>
      )}
    </div>
  );
}
function EditChildren({ item }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const editCredentialHandler = (name, value) => {
    setEditItem((prevState) => ({ ...prevState, [name]: value }));
  };
  const updateProfile = (event) => {
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const maxSize = 1 * 1024 * 1024;
    const file = event.target.files[0];
  
    if (file) {
      if (!validTypes.includes(file.type)) {
        alert('Please upload a valid image file (JPG, JPEG, or PNG).');
        return;
      }

      if (file.size > maxSize) {
        alert('File size should not exceed 1MB.');
        return;
      }
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setEditItem((prevState) => ({
          ...prevState,
          profile: reader.result,
          profile_file: file,
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  const updateChildrenHandler = async () => {
    try {
      const result = editChildrenSchema.safeParse(editItem);
      if (result.success) {
        setErrors(null);
        setLoading(true);
        const formData = new FormData();
        if (editItem.name) {
          formData.append("name", editItem.name);
        }
        if (editItem.date_of_birth) {
          formData.append(
            "date_of_birth",
            new Date(editItem.date_of_birth).toISOString().slice(0, 10)
          );
        }
        if (editItem.gender) {
          formData.append("gender", editItem.gender);
        }
        if (editItem.class) {
          formData.append("class", editItem.class);
        }
        if (editItem.school) {
          formData.append("school", editItem.school);
        }
        if (editItem.profile_file) {
          formData.append("profile", editItem.profile_file);
        }
        const res = await api.updateChildren(editItem.id, formData);
        if (res.status === 200) {
          toast.success("Child details updated successfully");
          dispatch(drawerAction(false));
        } else if (res.status === 422) {
          Object.values(res.data.data).forEach((error) => {
            toast.error(error[0]);
          });
        } else {
          toast.error("Server side error!Please try again later");
        }
        setLoading(false);
      } else {
        const errorsObject = result.error.errors.reduce((acc, error) => {
          const path = error.path.join(".");
          acc[path] = error.message;
          return acc;
        }, {});
        setErrors(errorsObject);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    if (item) {
      setEditItem(item);
    }
  }, [item]);
  return (
    <div className="w-100 h-100 px-2 px-md-4">
      <div className="profile-container overflow-y-scroll py-2">
        <div>
          <img
            src={editItem?.profile || avatar}
            alt="item.name"
            style={{ width: "100px", height: "100px", borderRadius: "50%" }}
          />
        </div>
        <div className="d-flex justify-content-between gap-2 w-100 pt-4">
          <div className="w-100">
            <input type="file" id="upload" onChange={updateProfile} hidden accept=".jpg,.jpeg,.png" />
            <label
              htmlFor="upload"
              className={`${Style.custom_uploader} ${Style.bg_primary} ${Style.fs_600} ${Style.fw_16} border-0 rounded d-flex align-items-center text-light gap-1 btn btn-sm`}
              style={{ height: "43px", width: "100%" }}
            >
              <span>
                <img src={uploadIcon} alt="upload" />
              </span>
              <span>Choose from Gallery</span>
            </label>
          </div>
        </div>
        <div className="d-flex flex-column gap-2 pt-2">
          <div className={Style.profile_input}>
            <input
              type="text"
              name="name"
              className="w-100 rounded"
              placeholder="Enter Name"
              value={editItem?.name}
              onChange={(event) =>
                editCredentialHandler("name", event.target.value)
              }
            />
            {errors && errors.name && (
              <div>
                <ErrorMessage message={errors.name} />
              </div>
            )}
          </div>
          <div
            className={`${Style.profile_input} ${Style.children_custom_date} position-relative`}
          >
            <DatePicker
              className="w-100 rounded"
              selected={editItem?.date_of_birth}
              onChange={(date) => editCredentialHandler("date_of_birth", date)}
              dateFormat="dd/MM/yyyy"
              showYearDropdown
              scrollableYearDropdown
              yearDropdownItemNumber={100}
              showMonthDropdown
              maxDate={new Date()}
              placeholderText="Select Date of Birth"
            />
            <img
              src={calenderIcon}
              alt="calender"
              className="position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          {errors && errors.date_of_birth && (
            <div>
              <ErrorMessage message={errors.date_of_birth} />
            </div>
          )}
          <div className={`${Style.profile_input} position-relative`}>
            <select
              name="gender"
              className={`${editItem?.gender ? "text-dark" : Style.color_gray_200} w-100 rounded`}
              value={editItem?.gender}
              onChange={(event) =>
                editCredentialHandler("gender", event.target.value)
              }
            >
              <option value="" disabled>
                Select Gender
              </option>
              <option value="male">Boy</option>
              <option value="female">Girl</option>
            </select>
            <img
              src={caretDown}
              alt="caret-down"
              className="position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          {errors && errors.gender && (
            <div>
              <ErrorMessage message={errors.gender} />
            </div>
          )}
          <div className={Style.profile_input}>
            <input
              type="text"
              name="class"
              className="w-100 rounded"
              placeholder="Enter Class"
              value={editItem?.class}
              onChange={(event) =>
                editCredentialHandler("class", event.target.value)
              }
            />
          </div>
          <div className={Style.profile_input}>
            <input
              type="text"
              name="school"
              className="w-100 rounded"
              value={editItem?.school}
              placeholder="Enter School Name"
              onChange={(event) =>
                editCredentialHandler("school", event.target.value)
              }
            />
          </div>
        </div>
      </div>
      <div className="profile-bottom">
        {!loading && (
          <button
            type="button"
            onClick={updateChildrenHandler}
            className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 py-1 save-btn`}
          >
            Save Changes
          </button>
        )}
        {loading && (
          <button
            disabled
            type="button"
            className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 py-1 save-btn`}
          >
            <Spinner animation="border" role="status" size="sm">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </button>
        )}
      </div>
    </div>
  );
}
